// src/components/MyComponent.tsx

import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import '../css/button.css'; // Assurez-vous que ce fichier CSS existe et contient les styles nécessaires

// Définition des types pour les props
interface buttonProps {
    title: string;
    icon: IconDefinition;
    color: string;
    onClick: () => void; // Ajout de la prop onClick
}

// Composant fonctionnel avec des props typées
const ButtonCustomIcon: React.FC<buttonProps> = ({ title, icon, color, onClick }) => {
    return (
        <button className="custom-button mx-2" style={{ backgroundColor: color }} onClick={onClick}>
            <FontAwesomeIcon icon={icon} className="button-icon" />
            <span className="button-title">{title}</span>
        </button>
    );
};

export default ButtonCustomIcon;
